/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { C as Combobox, d as defineCustomElement$1 } from './combobox.js';

const CalciteCombobox = Combobox;
const defineCustomElement = defineCustomElement$1;

export { CalciteCombobox, defineCustomElement };

//# sourceMappingURL=calcite-combobox.js.map